import { FC } from 'react';
import XUIModal, { XUIModalHeader, XUIModalBody, XUIModalFooter } from '@xero/xui/react/modal';
import XUIButton from '@xero/xui/react/button';

export interface IDeleteModalProps {
    cancelButtonText: string;
    deleteButtonText: string;
    title: string;
    showModal: boolean;
    isLoading?: boolean;
    qaHook?: string;
    onSecondaryClicked: () => void;
    onPrimaryClicked: () => void;
}

const DeleteModal: FC<IDeleteModalProps> = (props) => {
    const {
        cancelButtonText,
        deleteButtonText,
        onPrimaryClicked,
        onSecondaryClicked,
        showModal,
        title,
        qaHook,
        children,
        isLoading = false,
    } = props;

    return (
        <XUIModal isOpen={showModal} onClose={onSecondaryClicked} closeButtonLabel='Close'>
            <XUIModalHeader>{title}</XUIModalHeader>
            <XUIModalBody qaHook={`${qaHook}-body`}>{children}</XUIModalBody>
            <XUIModalFooter className='xui-actions xui-actions-layout xui-padding-large'>
                <XUIButton onClick={onSecondaryClicked} qaHook={`${qaHook}-cancel`} variant='standard'>
                    {cancelButtonText}
                </XUIButton>
                <XUIButton
                    className='xui-actions--primary'
                    onClick={onPrimaryClicked}
                    qaHook={`${qaHook}-confirm`}
                    variant='negative'
                    isLoading={isLoading}
                    loadingAriaLabel='Loading'
                >
                    {deleteButtonText}
                </XUIButton>
            </XUIModalFooter>
        </XUIModal>
    );
};

export default DeleteModal;
